import React from "react";
import LabsModule from "../../components/labs/LabsModule";

const Labs = () => {
  return <LabsModule />;
};

export default Labs;
